import { SUCCESS } from '../../../../../constants/action-postfix'
import {
  COMMISSION_MEMBERS_REQUEST,
  COMMISSION_MEMBER_ADD_REQUEST,
  COMMISSION_MEMBER_DELETE_REQUEST,
} from '../../commissionActionTypes'

const initialState = []

export const commissionMembersReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${COMMISSION_MEMBERS_REQUEST}${SUCCESS}`:
      return action.payload

    case `${COMMISSION_MEMBER_ADD_REQUEST}${SUCCESS}`:
      return [...state, action.payload]

    case `${COMMISSION_MEMBER_DELETE_REQUEST}${SUCCESS}`:
      return state.filter(member => member.id !== action.payload.id)

    default:
      return state
  }
}
